<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import SupplierForm from "./components/SupplierForm.vue"

defineProps<{
  supplier: {
    id: number
    company_id: number | ""
    name: string
    document: string
    email: string
  }
  companies: Array<{ id: number; name: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <SupplierForm
      mode="edit"
      title="Fornecedores"
      subtitle="Atualize dados cadastrais do fornecedor."
      :supplier="supplier"
      :companies="companies"
      :errors="errors"
    />
  </AppShell>
</template>

